import { createAction } from 'typesafe-actions';
// import { Mode } from './reducer';
import { ThemeModeType } from '@make-software/cspr-design';

export const setFeatureThemeSpotlight = createAction(
  'SET_FEATURE_THEME_SPOTLIGHT'
)<boolean>();

export const setMode = createAction('SET_MODE')<ThemeModeType>();
